import React from "react";

import { ReactComponent as HushBowlSVG } from "src/images/svg/hush-bowl.svg";

import "./hush-bowl.css";

export const HushBowl = ({ className }: { className?: string }) => {
	return <HushBowlSVG className={className} />;
};
